import { FC } from "react";

import { ColSize, DatePickerForm, InputForm, RowSize } from "../../../../../../../shared/components";
import { ValidateForm } from "../../../../../../../shared/utils";
import { SectionQuotation } from "../SectionQuotation";

interface ContactFormProps {
  componentId: string;
  showFullName?: boolean;
  requiredFullName?: boolean;
  showPhone?: boolean;
  requiredPhone?: boolean;
  showEmail?: boolean;
  requiredEmail?: boolean;
  showAvailability?: boolean;
  requiredAvailability?: boolean;
  showComments?: boolean;
  requiredComments?: boolean;
}

export const ContactForm: FC<ContactFormProps> = ({ componentId,
  showFullName = true,
  requiredFullName = true,
  showPhone = true,
  requiredPhone = true,
  showEmail = true,
  requiredEmail = true,
  showAvailability = true,
  requiredAvailability = true,
  showComments = true,
  requiredComments = false
}) => {
  const validateForm = new ValidateForm();

  return (
    <SectionQuotation level='h3' title='Información de Contacto' hasCard={false}>
      <RowSize>
        {showFullName && (
          <ColSize size={25}>
            <InputForm
              formProps={{
                label: 'Nombre y Apellido:',
                name: `fullname-contact-${componentId}`,
                rules: requiredFullName
                  ? validateForm.generateRules({
                      label: 'nombre y apellido',
                      rules: ['required', 'fullName'],
                    })
                  : undefined,
              }}
            />
          </ColSize>
        )}
        {showPhone && (
          <ColSize size={25}>
            <InputForm
              formProps={{
                label: 'Teléfono:',
                name: `phone-number-contact-${componentId}`,
                rules: requiredPhone
                  ? validateForm.generateRules({
                      label: 'teléfono',
                      rules: ['required', 'phone'],
                    })
                  : undefined,
              }}
            />
          </ColSize>
        )}
        {showEmail && (
          <ColSize size={25}>
            <InputForm
              formProps={{
                label: 'Correo Electrónico:',
                name: `email-contact-${componentId}`,
                rules: requiredEmail
                  ? validateForm.generateRules({
                      label: 'correo electrónico',
                      rules: ['required', 'email'],
                    })
                  : undefined,
              }}
            />
          </ColSize>
        )}
        {showAvailability && (
          <ColSize size={25}>
            <DatePickerForm
              rangePickerProps={{
                format: 'HH:mm',
                picker: 'time',
                showTime: { format: 'HH:mm' },
              }}
              formProps={{
                label: 'Disponibilidad Horaria:',
                name: `hours-for-contact-${componentId}`,
                rules: requiredAvailability
                  ? validateForm.generateRules({
                      label: 'disponibilidad horaria',
                      rules: ['required'],
                    })
                  : undefined,
              }}
              isRangePicker
            />
          </ColSize>
        )}
        {showComments && (
          <ColSize size={25}>
            <InputForm
              formProps={{
                label: 'Comentarios:',
                name: `comments-contact${componentId}`,
                rules: requiredComments
                  ? validateForm.generateRules({
                      label: 'comentarios',
                      rules: ['required'],
                    })
                  : undefined,
              }}
              inputTextAreaProps={{ rows: 1 }}
              isTextArea
            />
          </ColSize>
        )}
      </RowSize>
    </SectionQuotation>
  );
}